module.exports = "https://pearup-project-assets.s3.eu-central-1.amazonaws.com/scratch/assets/5b9cda4a0241e4447c71913b88000924.png";